import { Box, Typography } from "@mui/joy";

import type { MaterialLineItemOption } from "../../../types";
import { formatUnitPriceRange } from "../../../utils/materialPriceDisplay";

type ProductOptionContentProps = {
    product: MaterialLineItemOption;
};

/** Rich layout for each row in the product dropdown list. */
export function ProductOptionContent({ product }: ProductOptionContentProps) {
    const price = formatUnitPriceRange(product.MinPrice, product.MaxPrice);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                width: "100%",
                minWidth: 0,
                py: 0.25,
            }}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                    level="body-sm"
                    sx={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {product.ProductName}
                </Typography>
                <Typography
                    level="body-xs"
                    color="neutral"
                    sx={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {product.ManufactureName || "Unknown"}
                </Typography>
            </Box>
            {price && (
                <Typography
                    level="body-xs"
                    color="neutral"
                    sx={{
                        flexShrink: 0,
                        fontVariantNumeric: "tabular-nums",
                        whiteSpace: "nowrap",
                    }}
                >
                    ${price}
                </Typography>
            )}
        </Box>
    );
}

/** Compact label shown in the closed select trigger. */
export function ProductSelectValue({ product }: ProductOptionContentProps) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "baseline",
                gap: 0.5,
                minWidth: 0,
                overflow: "hidden",
            }}
        >
            <Typography
                level="body-sm"
                component="span"
                sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {product.ProductName}
            </Typography>
            <Typography
                level="body-sm"
                component="span"
                color="neutral"
                sx={{
                    flexShrink: 0,
                    whiteSpace: "nowrap",
                }}
            >
                ({product.ManufactureName || "Unknown"})
            </Typography>
        </Box>
    );
}
